export enum TagTypeEnum {
  User = 0,
  SystemProductTag = 1,
  StoreChannelDiscountVariantTag = 2,
  VariantAvailableForCustomizationTag = 3,
  SystemVariantTag = 4,
}
